var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Col',[_c('v-distpicker',{attrs:{"disabeld":_vm.disabeld,"type":_vm.type,"province":_vm.province,"city":_vm.city,"area":_vm.area},on:{"selected":_vm.onSelect}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }